import {useContext} from "react";
import {AuthContext} from "./AuthContext";

export const useAuth = () => {
  const {
    session,
  } = useContext(AuthContext);

  return {
    session,
  };
}
